/** A URL slug for a name: lowercase letters, digits and single hyphens, at most 32 characters. */
export function slugFromName(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 32);
}
